import { gql } from '@apollo/client';

export const ENVIAR_CONFORMIDADES = gql`
    mutation EnviarConformidades($input: EnviarConformidadesInput!) {
        enviarConformidades(input: $input) {
            success
            error
            valorEsperado {
                idConformidad
            }
        }
    }
`;